// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__tmxVc","summary":"AdvancePaymentDetails_summary__KWeV8","edit":"AdvancePaymentDetails_edit__GX6LJ"};